// Mapping of original URLs to their preferred canonical URLs
export const URL_CANONICAL_MAP: Record<string, string> = {
  '/menu/meals/protein-pizzas': '/menu/pizzas',
  // Add additional mappings as needed
};

// Function to retrieve the canonical URL for a given path
export const getCanonicalUrl = (urlPath: string): string => {
  return URL_CANONICAL_MAP[urlPath] ?? urlPath;
};
